<template>
  <div class="iframe-video">
    <iframe :src="videoUrl" allow="autoplay" muted="muted"></iframe>
  </div>
</template>

<script>
export default {
  name: 'WidgetVideoIframe',
}
</script>

<script setup>
const props = defineProps({
  videoUrl: String,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
